@if (errorMessage) {
  <tidy-error-message
    [text]="errorMessage" />
}

@if (windowService.isDesktopRes) {
  <tidy-desktop-header>
    <div class="wrappable-container">
      <tidy-text [header]="'Renter Agreements'" />
      <form [formGroup]="form" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
      <tidy-small-button
        [text]="'Add Agreement'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="goToAddAgreement()" />
    </div>
  </tidy-desktop-header>
}

@if (!windowService.isDesktopRes) {
  @if (allRows.length) {
    <form [formGroup]="form" novalidate action="#">
      <tidy-search-input
        formControlName="search"
        [placeholder]="'Search'"
        [icon]="'assets/img/search-header.svg'"
        class="header-search" />
    </form>
  }
}

<!-- Skeleton table while loading — rows float in with the entrance cascade;
     the real table below then replaces it in place, instantly (skipEntrance). -->
@if (!loaded) {
  <tidy-table
    [skeletonLoading]="true"
    [columnslabels]="headers" />
}

@if (loaded) {
  <tidy-table
    #tidyTable
    [dataSource]="shownRows"
    [displayedColumns]="headers"
    [columnslabels]="headers"
    (sortChange)="sortChanged($event)"
    [showColumnLines]="false"
    [rowsToShow]="50"
    [allRowIsClickable]="true"
    (cellClick)="onTableColumnClick($event)"
    [skipEntrance]="true"
    [blockSorting]="true" />
}
